export default {
  itens(state) {
    return state.itens;
  },
  item(state) {
    return state.item;
  },
  dialog(state) {
    return state.dialog;
  },
  news(state) {
    return state.news;
  }
  // enviar(state) {
  //   return state.enviar;
  // }
};
